<template>
  <div
    class="rfp-rr-most-helpful-critical-032-or rr-most-fav-review-right float-left"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <div class="rfp-rr-most-helpful-critical-033-or rr-most-fav-review-right-inner">
      <h3 class="rfp-rr-most-helpful-critical-034-or rr-sub-title black">{{ headerTitle }}</h3>
      <span v-if="noFavorableReviewFound" class="rfp-rr-most-helpful-critical-035-or">
        <span
          class="rfp-rr-most-helpful-critical-036-or review-stars"
          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
        >
          <vue-star-rating
            :increment="starRatingIncrementValue"
            :max-rating="starRatingMaxRatingValue"
            :inactive-color="starRatingInactiveColor"
            :active-color="starRatingActiveColor"
            :star-size="starRatingStarSize"
            :rating="overallRating"
            :read-only="true"
            :show-rating="false"
          >
          </vue-star-rating>
        </span>
        <p class="rfp-rr-most-helpful-critical-038-or clear">
          <span v-if="showHideNickname" class="rfp-rr-most-helpful-critical-039-or black bold">{{
            labelDate
          }}</span
          ><span v-if="showCreatedAt"> - {{ reviewDate }}</span>
        </p>
        <h3
          v-if="showHideSubTitle"
          class="rfp-rr-most-helpful-critical-040-or rr-sub-title black clear"
        >
          {{ subTitle }}
        </h3>
        <p class="rfp-rr-most-helpful-critical-041-or clear">
          <span class="rfp-rr-most-helpful-critical-042-or rr-sub-content-restricted"
            >{{ subContent }}
          </span>
          <span
            class="rfp-rr-most-helpful-critical-043-or bold rr-show-full-review"
            @click="showFullReviewPopup"
            >{{ showFullReview }}</span
          >
        </p>
        <p
          v-if="isProductFree && showFreeProduct"
          class="rfp-rr-most-helpful-favorable-review-152-or"
        >
          <span>{{ isProductFreeDisplayText }}</span>
        </p>
        <p class="rfp-rr-most-helpful-critical-044-or clear">{{ labelHelpful }}</p>
        <p
          class="rfp-rr-most-helpful-critical-045-or clear bold rr-see-more-reviews reviews-four-five"
          @click="filterRatingSpecific"
        >
          {{ filterStarReviews }}
        </p>
        <p
          v-if="commentAdded != ''"
          class="rfp-rr-most-helpful-critical-046-or clear bold rr-see-more-reviews reviews-four-five"
          @click="showComments"
        >
          {{ commentAddedButton }}
        </p>
        <p v-if="showCommentText" class="rfp-rr-most-helpful-critical-047-or comment___text">
          {{ commentAdded }}
        </p>
      </span>
      <span v-if="!noFavorableReviewFound" class="rfp-rr-most-helpful-critical-048-or">{{
        noFavorableReviewFoundText
      }}</span>
    </div>
    <div
      v-if="activePopup"
      class="rfp-rr-most-helpful-critical-049 review-popup-overlay"
      style="display: block"
    ></div>
    <rfp-ratings-show-full-review
      v-if="activePopup"
      :header-title="headerTitlePopup"
      :label-quality-of-product="labelQualityOfProduct"
      :rate-quality-of-product="rateQualityOfProduct"
      :summary="summary"
      :rrids="rrid"
      :helpful-labels="helpfulLabel"
      :reports="report"
      :reported-texts="reportedText"
      :report-texts="reportText"
      :is-helpful-cookies="isHelpfulCookie"
      :helpful-counts="helpfulCount"
      :not-helpful-counts="notHelpfulCount"
      :update-helpful-review-apis="updateHelpfulReviewApi"
      :update-not-helpful-review-apis="updateNotHelpfulReviewApi"
      :report-review-apis="reportReviewApi"
      :is-recommends="isRecommend"
      :helpful-icons="helpfulIcon"
      :helpful-icon-alts="helpfulIconAlt"
      :non-helpful-icons="nonHelpfulIcon"
      :non-helpful-icon-alts="nonHelpfulIconAlt"
      :recommend-list-icons="recommendListIcon"
      :recommend-icon-alt-texts="recommendIconAltText"
      :product-names="productName"
      :review-contents="subContent"
      :review-titles="subTitle"
      :facebook-captions="facebookCaption"
      :facebook-share-enableds="facebookShareEnabled"
      :share-display-configs="shareDisplayConfig"
      :facebook-icons="facebookIcon"
      :facebook-icon-alts="facebookIconAlt"
      :facebook-tool-tips="facebookToolTip"
      :show-hode-quality-of-products="showHodeQualityOfProduct"
      :show-hide-sub-titles="showHideSubTitle"
    >
    </rfp-ratings-show-full-review>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import VueStarRating from 'vue-star-rating';
import RfpRatingsShowFullReview from '@/components/widget/rfp-ratings-show-full-review/rfp-ratings-show-full-review.vue';

export default {
  name: 'rfp-ratings-most-helpful-critical-review',
  components: {
    VueStarRating,
    RfpRatingsShowFullReview,
  },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    labelDate: {
      type: String,
      required: false,
    },
    reviewDate: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String,
      required: false,
    },
    subContent: {
      type: String,
      required: false,
    },
    showFullReview: {
      type: String,
      required: true,
    },
    labelHelpful: {
      type: String,
      required: false,
    },
    filterStarReviews: {
      type: String,
      required: true,
    },
    noFavorableReviewFound: {
      type: Boolean,
      required: true,
    },
    noFavorableReviewFoundText: {
      type: String,
      required: true,
    },
    headerTitlePopup: {
      type: String,
      required: false,
    },
    labelQualityOfProduct: {
      type: String,
      required: true,
    },
    rateQualityOfProduct: {
      type: String,
      required: true,
    },
    summary: {
      type: String,
      required: false,
    },
    rrid: {
      type: Number,
      required: true,
    },
    helpfulLabel: {
      type: String,
      required: true,
    },
    report: {
      type: String,
      required: false,
    },
    reportedText: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    isHelpfulCookie: {
      type: String,
      required: false,
    },
    helpfulCount: {
      type: Number,
      required: false,
    },
    notHelpfulCount: {
      type: Number,
      required: false,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReviewApi: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    isRecommend: {
      type: String,
      required: false,
    },
    commentAddedButton: {
      type: String,
      required: true,
    },
    commentAdded: {
      type: String,
      required: true,
    },
    helpfulIcon: {
      type: String,
      required: true,
    },
    helpfulIconAlt: {
      type: String,
      required: true,
    },
    nonHelpfulIcon: {
      type: String,
      required: true,
    },
    nonHelpfulIconAlt: {
      type: String,
      required: true,
    },
    recommendListIcon: {
      type: String,
      required: true,
    },
    recommendIconAltText: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    facebookCaption: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabled: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfig: {
      type: String,
      required: true,
    },
    facebookIcon: {
      type: String,
      default: '',
    },
    facebookIconAlt: {
      type: String,
      default: '',
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showHideNickname: {
      type: Boolean,
      required: true,
    },
    showCreatedAt: {
      type: Boolean,
      default: true,
    },
    showHideSubTitle: {
      type: Boolean,
      required: true,
    },
    showHodeQualityOfProduct: {
      type: Boolean,
      required: true,
    },
    isProductFree: {
      type: Boolean,
      required: false,
    },
    isProductFreeDisplayText: {
      type: String,
      required: '',
    },
    showFreeProduct: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      overallRating: this.rating,
      activePopup: false,
      showCommentText: false,
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('helpfulPopupStatus', () => {
      this.activePopup = false;
    });
  },
  methods: {
    showFullReviewPopup() {
      this.activePopup = true;
    },
    showComments() {
      /* istanbul ignore next */
      if (this.showCommentText === true) {
        /* istanbul ignore next */
        this.showCommentText = false;
      } else {
        this.showCommentText = true;
      }
      // this.showCommentText = this.showCommentText ? false : true;
    },
    closeFullReviewPopup() {
      this.activePopup = false;
    },
    filterRatingSpecific() {
      eventBus.emit('oneTwoThree');
    },
  },
};
</script>
